<div class="page">
  <span class="eyebrow">Vi hjälper dig</span>
  <h1>Kontakta oss</h1>

  <div class="panel">
    <p>
      Ring till oss på 0295-210 45, tryck 1 för att komma till däckverkstaden och 2 för att komma till bilverkstaden.
      Så hjälper vi dig!
    </p>

    <div class="contact-tiles">
      <a class="contact-tile" href="tel:+4629521045">
        <span class="contact-tile__label">Ring oss</span>
        <span class="contact-tile__value">0295-210 45</span>
      </a>
      <a class="contact-tile" href="mailto:verkstad.osterbydack@hotmail.com">
        <span class="contact-tile__label">Maila bilverkstad</span>
        <span class="contact-tile__value">verkstad.osterbydack&#64;hotmail.com</span>
      </a>
      <a class="contact-tile" href="mailto:osterbydack@hotmail.com">
        <span class="contact-tile__label">Maila däckverkstad</span>
        <span class="contact-tile__value">osterbydack&#64;hotmail.com</span>
      </a>
    </div>
  </div>
</div>
